import React from "react";
import { connect } from "react-redux";
import { AppState } from "src/redux/store";
import { getPrestation, getProject } from "src/redux/projects/selectors";
import ProposalsList from "src/components/ProposalsList";
import * as Stories from "src/redux/stories";

interface Props {
  projectId: number;
  prestationId: number;
}

function mapStateToProps(state: AppState, props: Props) {
  return {
    project: getProject(state.projects, props),
    prestation: getPrestation(state.projects, props)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadProposals: (projectId: number, prestationId: number) =>
      dispatch(Stories.fetchProposalsListOnce(projectId, prestationId))
  };
}

type PropsWithMapState = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  Props;

class ProposalsListContainerToConnect extends React.Component<
  PropsWithMapState
> {
  async componentWillMount() {
    await this.props.loadProposals(
      this.props.projectId,
      this.props.prestationId
    );
  }

  render() {
    if (!this.props.prestation || !this.props.project) {
      return null;
    }

    return (
      <ProposalsList
        project={this.props.project}
        prestation={this.props.prestation}
        proposals={this.props.prestation.proposals}
        isLoading={this.props.prestation.isLoadingProposals}
      />
    );
  }
}

export const ProposalsListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ProposalsListContainerToConnect);



// WEBPACK FOOTER //
// ./src/containers/ProposalsListContainer.tsx